type Props = {
  text: string;
  className?: string;
};
export function FormattedText({ text, className }: Props) {
  return (
    <p className={["whitespace-pre-wrap", className ?? ""].join(" ")}>{text}</p>
  );
}
